import {
  COMMS_DIRECT_ROOMS,
  COMMS_LIVEKIT_TOKEN,
  COMMS_SESSION,
} from '@/api/Core/endpoints';
import { Core } from '@/api/Core/Core';
import {
  CommsSession,
  CommsSessionRequest,
  DirectRoom,
  DirectRoomDirectoryEntry,
  LiveKitToken,
  LiveKitTokenRequest,
} from './types';

class CommsApi extends Core {
  createSession = (request: CommsSessionRequest) =>
    this.post<CommsSession>(COMMS_SESSION(), request);

  endSession = (request: CommsSessionRequest) =>
    this.delete(COMMS_SESSION(), request);

  ensureDirectRoom = (peerOperatorId: number) =>
    this.post<DirectRoom>(COMMS_DIRECT_ROOMS(), { peerOperatorId });

  listDirectRooms = () =>
    this.get<DirectRoomDirectoryEntry[]>(COMMS_DIRECT_ROOMS());

  getLiveKitToken = (request: LiveKitTokenRequest) =>
    this.post<LiveKitToken>(COMMS_LIVEKIT_TOKEN(), request);
}

export const comms = new CommsApi();
